var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search"},[_c('input',{ref:_vm.inputRef,class:{
            'search__input': true,
            'search__input--no-search-icon': _vm.hideSearchIcon,
        },attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.defaultValue},on:{"blur":_vm.handleBlur,"focus":_vm.handleFocus,"input":_vm.checkDebounce}}),(!_vm.hideSearchIcon)?_c('span',{staticClass:"icon-search",on:{"click":function($event){return _vm.$emit('submit')}}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }